<template>
    <div id="pancake-seeder">
        <div class="vx-card p-2">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full flex items-center">
                    <h4>Cấu hình Seeder</h4>
                </div>
                <div class="vx-col md:w-1/2 w-full flex justify-end gap-3">
                    <vs-button color="primary" icon-pack="feather" icon="icon-plus" @click="openPopupSeeder">
                        {{ $t('settings.add') }}
                    </vs-button>
                </div>
            </div>
        </div>
        <vx-card class="mt-4">
            <div class="vx-row">
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">Phòng ban</label>
                    <v-select class="w-full" v-model="selectedDepartmentId" :options="departmentOptions"
                        :clearable="false">
                        <template #option="{ label, organizationBranchName }">
                            <h5 style="margin: 0">{{ label }}</h5>
                            <em>{{ organizationBranchName }}</em>
                        </template>
                        <template #selected-option="{ label, organizationBranchName }">
                            <div class="flex items-center gap-2">
                                <strong>{{ label }}</strong>
                                <em>{{ organizationBranchName }}</em>
                            </div>
                        </template></v-select>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">Tên</label>
                    <vs-input class="w-full" v-model="fullName"></vs-input>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">Facebook ID</label>
                    <vs-input class="w-full" v-model=facebookId></vs-input>
                </div>
                <div class="vx-col md:w-1/2 mt-4">
                    <vs-button color="primary" icon-pack="feather" icon="icon-search" @click="getDataSeeder">
                        {{ $t('menuPackage.search') }}
                    </vs-button>
                </div>
            </div>
            <vs-table stripe :data="dataSeeder" noDataText="Không có dữ liệu" class="mt-8">
                <template slot="thead">
                    <vs-th>
                        STT
                    </vs-th>
                    <vs-th>
                        Tên
                    </vs-th>
                    <vs-th>
                        Phòng ban
                    </vs-th>
                    <vs-th>
                        Facebook ID
                    </vs-th>
                    <vs-th>
                        Hành động
                    </vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            {{ pageSize * pageNumber + indextr + 1 }}
                        </vs-td>

                        <vs-td>
                            {{ tr.fullName }}
                        </vs-td>

                        <vs-td>
                            {{ tr.departmentIdRender }}
                        </vs-td>

                        <vs-td>
                            {{ tr.facebookId }}
                        </vs-td>

                        <vs-td>
                            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top">
                                <feather-icon icon="EditIcon" class="text-primary mr-2"
                                    svgClasses="h-5 w-5 cursor-pointer" @click.stop="editElement(tr)" />
                            </vx-tooltip>
                            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                                <feather-icon icon="TrashIcon" class="text-danger" svgClasses="h-5 w-5 cursor-pointer"
                                    @click.stop="confirmDelete(tr)" />
                            </vx-tooltip>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <div class="vx-row mt-4" v-if="dataSeeder.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        dataSeeder.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : dataSeeder.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                </div>
            </div>
        </vx-card>

        <vs-popup class="holamundo" title="Chỉnh sửa thông tin" :active.sync="popupEditSeeder" id="edit-seeder-info"
            v-if="popupEditSeeder">
            <div class="vx-row">
                <div class="vx-col lg:w-1/3 w-full">
                    <label class="vs-input--label">Phòng ban</label>
                    <v-select class="w-full" v-model="dataSelected.departmentId" :reduce="item => item.value"
                        :options="departmentOptionsCreate" :clearable="false">
                        <template #option="{ label, organizationBranchName }">
                            <h5 style="margin: 0">{{ label }}</h5>
                            <em>{{ organizationBranchName }}</em>
                        </template>
                        <template #selected-option="{ label, organizationBranchName }">
                            <div class="flex items-center gap-2">
                                <strong>{{ label }}</strong>
                                <em>{{ organizationBranchName }}</em>
                            </div>
                        </template></v-select>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">Tên</label>
                    <vs-input class="w-full" v-model="dataSelected.fullName"></vs-input>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">Facebook ID</label>
                    <vs-input class="w-full" v-model=dataSelected.facebookId></vs-input>
                </div>
                <div class="vx-col w-full mt-6 flex justify-end gap-2">
                    <vs-button @click="updateDataSeeder">{{ $t('button.update') }}</vs-button>
                    <vs-button type="border" color="danger" @click="cancelUpdate">{{ $t('button.cancel') }}</vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup class="holamundo" title="Tạo mới thông tin" :active.sync="popupSeeder" id="add-seeder-info">
            <div class="vx-row">
                <div class="vx-col lg:w-full w-full">
                    <label class="vs-input--label">Phòng ban</label>
                    <v-select class="w-full" v-model="selectedDepartmentIdCreated" :options="departmentOptionsCreate"
                        :reduce="item => item.value" :clearable="false">
                        <template #option="{ label, organizationBranchName }">
                            <h5 style="margin: 0">{{ label }}</h5>
                            <em>{{ organizationBranchName }}</em>
                        </template>
                        <template #selected-option="{ label, organizationBranchName }">
                            <div class="flex items-center gap-2">
                                <strong>{{ label }}</strong>
                                <em>{{ organizationBranchName }}</em>
                            </div>
                        </template></v-select>
                </div>
                <div v-for="(info, index) in tempSeederInfo" :key="index" class="vx-col lg:w-full w-full">
                    <div class="flex gap-5 mt-2 flex-nowrap">
                        <div class="w-full">
                            <label class="vs-input--label">Tên</label>
                            <vs-input class="w-full" v-model="info.fullName"></vs-input>
                        </div>
                        <div class="w-full">
                            <label class="vs-input--label">Facebook ID</label>
                            <vs-input class="w-full" v-model="info.facebookId"></vs-input>
                        </div>
                        <div class="col-icon-delete">
                            <vx-tooltip :text="$t('button.delete')" position="top">
                                <feather-icon icon="TrashIcon" svgClasses="h-5 w-5" class="text-danger"
                                    @click="deleteInfo(index)" />
                            </vx-tooltip>
                        </div>
                    </div>

                </div>
                <div class="vx-col mt-4">
                    <vx-tooltip class="mt-1 ml-auto" :text="$t('button.add')" position="top">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ml-1 text-success"
                            @click="addSeederInfo" />
                    </vx-tooltip>

                </div>
                <div class="vx-col w-full mt-6 flex justify-end gap-2">
                    <vs-button @click="saveSeeder">{{ $t('button.create') }}</vs-button>
                    <vs-button type="border" color="danger" @click="closePopup">{{ $t('button.cancel')
                        }}</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: "PancakeSeeder",
    components: {
        vSelect
    },
    data() {
        return {
            dataSeeder: [],
            pageSize: 20,
            pageNumber: 0,
            currentPage: 1,
            totalPages: 0,
            totalElements: 0,
            fullName: null,
            facebookId: null,
            selectedDepartmentId: { label: 'Tất cả', value: null },
            selectedDepartmentIdCreated: null,
            departmentOptions: [],
            departmentOptionsCreate:[],
            popupEditSeeder: false,
            popupSeeder: false,
            dataSelected: null,
            seederInfo: [
            ],
            tempSeederInfo: [{departmentId:null,fullName: '', facebookId: ''}],
        }
    },

    async created() {
        await this.getDepartmentBussiness();
        await this.getDataSeeder();
    },

    methods: {
        closePopup() {
            this.popupSeeder = false

        },
        saveSeeder() {
            this.tempSeederInfo[0].departmentId = this.selectedDepartmentIdCreated;
            this.seederInfo = this.tempSeederInfo;
            // this.tempSeederInfo = [];
            if (!this.selectedDepartmentIdCreated) {
                return this.$vs.notify({
                    text: 'Vui lòng nhập đầy đủ phòng ban!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'warning'
                });
            }
            for (let i = 0; i < this.seederInfo.length; i++) {
                const info = this.seederInfo[i];

                if (!info.fullName || !info.facebookId) {
                    return this.$vs.notify({
                        text: 'Vui lòng nhập đầy đủ Tên và Facebook ID cho tất cả các trường!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    });
                }

                let user = this.seederInfo.find(x => x.facebookId === info.facebookId && this.seederInfo.indexOf(x) !== i)
                if (user) {
                    return this.$vs.notify({
                        text: 'Không nhập Facebook ID trùng nhau!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    });
                }
            }
            this.$vs.loading();
            this.$crm.post('/loyalty/potential-customer-seeder/creates', this.seederInfo).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Thêm mới thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.popupSeeder = false;
                this.getDataSeeder();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        deleteInfo(index) {
            this.tempSeederInfo.splice(index, 1);
        },
        addSeederInfo() {
            if (this.selectedDepartmentIdCreated) {
                this.tempSeederInfo.push({ departmentId: this.selectedDepartmentIdCreated, fullName: '', facebookId: '' });
            } else {
                return this.$vs.notify({
                    text: 'Vui lòng chọn phòng ban !',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
        },
        openPopupSeeder() {
            this.tempSeederInfo = [{departmentId:null,fullName: '', facebookId: ''}]
            this.selectedDepartmentIdCreated = null
            this.popupSeeder = true;
        },
        getDataSeeder() {
            let payload = {
                fullName: this.fullName,
                facebookId: this.facebookId,
                departmentId: this.selectedDepartmentId.value,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }

            this.$vs.loading();
            this.$crm.post('/loyalty/potential-customer-seeder/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.dataSeeder = res.data.content
                    this.totalPages = res.data.totalPages
                    this.totalElements = res.data.totalElements
                    this.dataSeeder.map(el => {
                        if (this.departmentOptions) {
                            this.departmentOptions.map(t => {
                                if (t.value === el.departmentId) {
                                    el.departmentIdRender = t.label
                                }
                            })
                        }

                    })

                }
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        getDepartmentBussiness() {
            return new Promise((resolve, reject) => {
                let payload = {}
                this.$vs.loading();
                this.$crm.post('/department/find-all-pancake', payload).then(res => {
                    let branchList = JSON.parse(localStorage.getItem('branchInfoList'))
                    this.departmentOptions = res.data.map(el => {
                        return {
                            label: el.departmentName,
                            organizationBranchName: branchList.find(x => x.id === el.organizationBranchId).organizationBranchName,
                            value: el.id
                        }
                    })
                    this.departmentOptionsCreate = res.data.map(el => {
                        return {
                            label: el.departmentName,
                            organizationBranchName: branchList.find(x => x.id === el.organizationBranchId).organizationBranchName,
                            value: el.id
                        }
                    })
                    this.departmentOptions.unshift({ value: null, label: 'Tất cả' })
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getDataSeeder();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getDataSeeder();
        },

        confirmDelete(data) {
            this.$vs.dialog({
                title: 'Xác nhận xóa',
                type: 'confirm',
                color: 'danger',
                text: 'Bạn có chắc chắn muốn xóa tài khoản ' + `"${data.fullName}"?`,
                accept: () => this.deleteRecord(data),
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteRecord(data) {
            this.$vs.loading();
            this.$crm.post(`/loyalty/potential-customer-seeder/delete/${data.id}`).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Xóa thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.getDataSeeder();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        editElement(data) {
            this.dataSelected = data;
            this.popupEditSeeder = true;
        },

        updateDataSeeder() {
            this.$vs.loading();
            this.$crm.post(`/loyalty/potential-customer-seeder/update/${this.dataSelected.id}`, this.dataSelected).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Xóa thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.cancelUpdate();
                this.getDataSeeder();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        cancelUpdate() {
            this.dataSelected = null;
            this.popupEditSeeder = false;
        }
    },
}
</script>

<style lang="scss">
#edit-seeder-info {
    @media (min-width: 1560px) {
        .vs-popup {
            width: 60% !important;
        }
    }
}
#add-seeder-info {
    @media (min-width: 1560px) {
        .vs-popup {
            width: 60% !important;
        }
    }
}
</style>
<style scoped>
@media (min-width:1120px) {
    .flex-nowrap {
        flex-wrap: nowrap;
    }

    .col-icon-delete {
        margin-top: 28px;
    }
}

@media (min-width:460px) {
    .flex-nowrap {
        flex-wrap: nowrap;
    }

    .col-icon-delete {
        margin-top: 28px;
    }
}
</style>
